import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function SceneClimax() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = root.current;
    if (!el) return;

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top top",
          end: "+=240%",
          scrub: 1,
          pin: true,
        },
      });

      // Start inside a giant letter (letter A basically full-screen), slowly zoom out
      tl.fromTo(".climax-giant", {
        scale: 18,
        transformOrigin: "50% 50%",
      }, {
        scale: 1,
        duration: 1.6,
        ease: "power2.inOut",
      }, 0);

      tl.to(".climax-giant", {
        opacity: 0,
        duration: 0.3,
      }, 1.55);

      // Lock words to grid
      tl.fromTo(".climax-line-1", { yPercent: 40, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.6 }, 1.2);
      tl.fromTo(".climax-line-2", { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.6 }, 1.4);

      // Compress into REMI
      tl.to(".climax-line-1, .climax-line-2", {
        letterSpacing: "-0.4em",
        opacity: 0,
        duration: 0.6,
      }, 2.4);

      tl.fromTo(".climax-remi", {
        opacity: 0,
        scale: 0.7,
      }, {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "power3.out",
      }, 2.6);
    }, root);

    return () => ctx.revert();
  }, []);

  return (
    <section
      id="scene-climax"
      ref={root}
      data-theme="signal"
      className="relative h-screen w-full overflow-hidden signal-bg"
    >
      <div className="absolute top-24 left-6 md:left-10 type-label text-[color:var(--ink)]">
        06 / CLIMAX
      </div>
      <div className="absolute top-24 right-6 md:right-10 type-label text-[color:var(--ink)] text-right">
        THE ONLY LARGE COLOR MOMENT
      </div>

      <div className="climax-giant absolute inset-0 flex items-center justify-center type-display text-[color:var(--ink)] pointer-events-none"
           style={{ fontSize: "40vw", lineHeight: 0.8 }}>
        A
      </div>

      <div className="absolute inset-0 flex flex-col items-start justify-center px-6 md:px-16">
        <div className="climax-line-1 type-display text-[color:var(--ink)]" style={{ fontSize: "clamp(3.5rem, 10vw, 12rem)" }}>
          NOT AN AGENCY.
        </div>
        <div className="climax-line-2 type-display text-[color:var(--ink)] mt-2" style={{ fontSize: "clamp(3.5rem, 10vw, 12rem)" }}>
          A ONE-PERSON POWERHOUSE.
        </div>
      </div>

      <div className="climax-remi absolute inset-0 flex items-center justify-center opacity-0 type-display text-[color:var(--ink)] pointer-events-none"
           style={{ fontSize: "34vw", lineHeight: 0.8 }}>
        REMI
      </div>

      <div className="absolute bottom-6 left-0 right-0 px-6 md:px-10 flex items-end justify-between">
        <div className="type-label text-[color:var(--ink)]">SIGNAL / MAX</div>
        <div className="type-label text-[color:var(--ink)]">FRAME 072</div>
      </div>
    </section>
  );
}